"use client"

import classNames from "classnames"
import { rootNavigationState } from "features/navigation/state/rootNavigationState"
import dynamic from "next/dynamic"
import React from "react"

import { useUser } from "@clerk/nextjs"

import ApplicationHeader from "./ApplicationHeader"
import SideNavigationMenu from "./SideNavigationMenu"

interface INavigationWrapper {
    children: React.ReactNode
    allowAppAccess?: boolean
}

const OrgGroupSelectorModalDynamic = dynamic(
    () => import("features/account/accountSelection/OrgGroupSelectorModal"),
    { ssr: false, loading: () => <p>Loading...</p> }
)
const BrewInsightsModalDynamic = dynamic(
    () => import("features/legacyFeatures/BrewInsights/components/BrewInsightsModal"),
    { ssr: false, loading: () => <p>Loading...</p> }
)
const ConfirmationModalDynamic = dynamic(
    () => import("components/legacyComponents/modals/ComfirmationModal"),
    { ssr: false, loading: () => <p>Loading...</p> }
)
const TapSensorActionsModalDynamic = dynamic(
    () => import("../legacyFeatures/resolveTap/components/modal/TapSensorActionsModal"),
    { ssr: false, loading: () => <p>Loading...</p> }
)

const NavigationWrapper: React.FC<INavigationWrapper> = ({ children, allowAppAccess = true }) => {
    const { user } = useUser()

    const [displayNavigation] = React.useState<boolean>(allowAppAccess)

    const navIsExpanded = rootNavigationState.use.navIsExpanded()
    const navIsHidden = rootNavigationState.use.navIsHidden()

    return (
        <>
            <ApplicationHeader allowAppAccess={!!user && allowAppAccess} />
            {displayNavigation && allowAppAccess && <SideNavigationMenu />}
            <div
                className={classNames(
                    navIsHidden || !allowAppAccess
                        ? "p-0"
                        : navIsExpanded
                          ? "lg:pl-72"
                          : "pl-0 lg:pl-8",
                    displayNavigation ? "" : "pl-0"
                )}
            >
                {children}
            </div>
            <OrgGroupSelectorModalDynamic />
            <BrewInsightsModalDynamic />
            <ConfirmationModalDynamic />
            <TapSensorActionsModalDynamic />
        </>
    )
}

export default NavigationWrapper
